import Select from 'react-select';
import _noop from 'lodash/noop';
import { SearchIcon } from '@heroicons/react/outline';

export function BroadcastFilter({
  search = _noop,
  setDetails = {},
  details = {},
  options = [],
  onFilter,
  activeFilter,
  filterKeys = [],
}) {
  return (
    <div className="box">
      <div className="box-wrapper">
        <div className="bg-white rounded flex items-center w-full p-3 shadow-sm border border-gray-200">
          {filterKeys.map((filter) => (
            <button
              key={filter}
              onClick={() => onFilter(filter)}
              className={`btn w-1/6 m-1 text-sm outline-none hover:bg-gray-200 shadow-sm border border-gray-200 p-2 ${
                activeFilter === filter ? 'bg-gray-200' : ''
              }`}
              disabled={activeFilter === filter}
            >
              {/* TODO: change category on backend so that digital is ott */}
              {filter === 'DIGITAL' ? 'OTT' : filter}
            </button>
          ))}

          <div className="relative flex-grow">
            <input
              type="search"
              name=""
              id=""
              placeholder="Type search term here..."
              className="w-full pl-4 text-lg outline-none focus:outline-none bg-transparent"
              value={details.term || ''}
              onChange={(event) => {
                setDetails((prevState) => ({
                  ...prevState,
                  term: event.target.value,
                }));
              }}
              onKeyUp={(event) => {
                if (event.key === 'Enter') {
                  search();
                }
              }}
            />
            {details.term && (
              <button
                className="absolute right-0 top-1/2 transform -translate-y-1/2 mr-2 text-gray-400 hover:text-gray-600"
                onClick={() => {
                  setDetails((prevState) => ({
                    ...prevState,
                    term: '',
                  }));
                }}
              >
                <i className="fas fa-times"></i>
              </button>
            )}
          </div>

          {options.length !== 0 ? (
            <div className="select mr-3">
              <Select
                id="search_type"
                name="search_type"
                placeholder="No Types"
                isMulti
                options={options}
                classNamePrefix="multi-select"
                className={`multi-select text-xs w-full`}
                onChange={(event) => {
                  setDetails((prevState) => ({
                    ...prevState,
                    term_types: [...event].map((option) => option.value),
                  }));
                }}
                defaultValue={0}
                value={
                  Object.keys(options).length !== 0
                    ? details?.search_types?.map((selectedOption) => {
                        return options[
                          options.findIndex(
                            (option) => option.value === selectedOption
                          )
                        ];
                      })
                    : 0
                }
              />
            </div>
          ) : null}
          <SearchIcon
            className={`h-8 w-8 pt-1.5 ${search ? 'cursor-pointer' : ''}  ${
              search ? 'hover:' : ''
            }text-green-500 mx-4`}
            aria-hidden="true"
            onClick={search}
          />
        </div>
      </div>
    </div>
  );
}
